import { callAPI } from "../config/api";

const PATH_API = process.env.REACT_APP_API;

export async function getProvinsi(data: any) {
    const url = `${PATH_API}/location/provinsi`;
    return await callAPI({
        url,
        method: "GET",
        params: data
    });
}


export async function getCity(data: any) {
    const url = `${PATH_API}/location/city`;
    return await callAPI({
        url,
        method: "GET",
        params: data
    });
}


export async function getDistrict(data: any) {
    const url = `${PATH_API}/location/district`;
    return await callAPI({
        url,
        method: "GET",
        params: data
    });
}